import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import withTheme from 'core/hocs/withTheme';

import themePropTypes from 'core/utils/prop-types/theme';

import styles from './index.styl';

function Bullet(props) {
  const {
    active,
    onSelect,
    theme,
  } = props;

  const {
    const: {
      size,
    },
    basic: stateAtoms,
    basic: {
      active: {
        background: activeStateBackground,
        boxShadow: activeStateShadow,
      },
    },
  } = theme.controls.bullet;

  return (
    <Fragment>
      <style jsx>{`
        .bullet
          width ${size}
          height ${size}
          cursor ${active ? 'default' : 'pointer'}
          background ${active ? activeStateBackground : stateAtoms.idle.background}
          box-shadow ${active ? activeStateShadow : 'none'}
          transition background ${props.theme.animations.hover}
          &:hover
            background ${active ? activeStateBackground : stateAtoms.hover.background}
          &:active
            background ${active ? activeStateBackground : stateAtoms.active.background}
      `}</style>
      <div
        className={cx('bullet', styles.bullet)}
        onClick={active ? undefined : onSelect}
      />
    </Fragment>
  );
}

const stateContract = `
  {
    background,
  }
`;

Bullet.propTypes = {
  /**
   * Булевый признак активного/неактивного буллета
   */
  active: PropTypes.bool,
  /**
   * Обработчик события выбора буллета
   */
  onSelect: PropTypes.func,
  /** @ignore */
  theme: themePropTypes(`
    {
      animations: {
        hover,
      },
      controls: {
        bullet: {
          const: {
            size,
          },
          basic: {
            idle: ${stateContract},
            hover: ${stateContract},
            active: ${stateContract},
          },
        },
      },
    },
  `),
};

Bullet.defaultProps = {
  active: false,
};

const BulletWithHOCs = withTheme(Bullet);
BulletWithHOCs.displayName = 'Bullet';

export { Bullet as StorybookComponent };
export default BulletWithHOCs;
